
import { Component, Vue } from "vue-property-decorator";
import { namespace } from "vuex-class";
import { emptyToLine, splitThousands } from "@common/src/utils/common";
import TableEnableFlag from "@/components/scope/table-enable-flag.vue";
import DataImport from "@common/src/components/scope/data-import/index.vue";
import SwitchStatus from "@common/src/components/scope/switch-status/index.vue";
import { Table, TableRowsSelect, InjectFunction } from "@common/src/utils/decorator";
import { addCurrencyUnit } from "@common/src/utils/tools";
import MyCheckbox from "@common/src/components/scope/my-checkbox/index.vue";
import StandardFlag from "@common/src/components/scope/standard-flag/index.vue";

import t from "@common/src/i18n/t";
const parts = namespace("parts");
const base = namespace("base");
const partsCategory = namespace("parts-category");
const common_base = namespace("common_base");
@InjectFunction("permit")
@Component({
  components: { TableEnableFlag, DataImport, SwitchStatus, MyCheckbox, StandardFlag }
})
@Table("loadListData")
@Table.DataImport({
  templateUrl: "https://static.gtech.asia/static/template/speedbiz/零配件导入.xlsx",
  actionUrl: "/filecloud/importPartsV2"
})
@TableRowsSelect({
  warningMsg: t("setting.select-spare-parts"),
  updateStatusFuncName: "confirmUpdateStatus",
  tableRefKey: "table"
})
export default class Parts extends Vue {
  @parts.Action getPartsList;
  @parts.Action updateStatus;
  @partsCategory.Action getCategoryList;
  @base.Action getDictionaryList;
  @parts.Action getPartsBrandList;
  @common_base.State showPlatformParts;
  splitThousands = splitThousands;
  emptyToLine = emptyToLine;
  addCurrencyUnit = addCurrencyUnit;
  searchForm = {
    partsName: "",
    partsNumber: "",
    brandCode: "",
    categoryCode: ""
  };
  sortForm: {};
  partsList: any[] = [];
  get searchList() {
    return [
      {
        label: t("parts.name"),
        type: "input",
        value: "",
        prop: "partsName"
      },
      {
        label: t("parts.code"),
        type: "input",
        value: "",
        prop: "partsNumber"
      },
      {
        label: t("setting.brand"),
        type: "select",
        selectList: this.brandList,
        value: "",
        prop: "brandCode"
      },
      {
        label: t("parts.category"),
        type: "cascader",
        prop: "categoryCode",
        value: "",
        options: this.categoryList,
        props: {
          label: "categoryName",
          value: "categoryCode"
        }
      }
    ];
  }
  categoryList: any[] = [];
  brandList: any[] = [];
  created() {
    this.init();
  }
  async init() {
    this.loadListData();
    this.getBrandList();
    const data = await this.getCategoryList();
    this.categoryList = this.addLeafFlag(this.$safeValue(data, "data", []));
  }
  getBrandList() {
    this.getPartsBrandList().then(data => {
      this.brandList = this.$safeValue(data, "data.list", []).map(item => ({
        label: item.brandName,
        value: item.brandCode
      }));
    });
  }
  @Table.LoadDataMethod()
  loadListData() {
    return this.getPartsList({
      status: "9",
      orderItems: this.mix_sortParams,
      ...this.searchForm,
      pageNum: this.mix_pageNum,
      pageSize: this.mix_pageSize,
      partsName: this.searchForm.partsName,
      notOpadmin: this.showPlatformParts ? "0" : "1",
      partsRuleTypeList: [1, 2, 3]
    }).then(data => {
      this.partsList = this.$safeValue(data, "data.list", []);
      return data;
    });
  }
  addLeafFlag(list) {
    const f = function (list) {
      list.forEach(item => {
        if (!item.children || item.children.length < 1) {
          delete item.children;
        } else {
          f(item.children);
        }
      });
    };
    f(list);
    return list;
  }
  @TableRowsSelect.updateMethod
  confirmUpdateStatus(status, selectedRow) {
    this.updateStatus({
      status: status,
      partsCode: selectedRow ? [selectedRow.partsCode] : this.mix_selectedRows.map(item => item.partsCode)
    }).then(() => {
      this.$message.success(status ? t("setting.enable-successful") : t("setting.disable-success"));
      this.loadListData();
    });
  }
  handleEdit(row) {
    this.$router.push(`/setting/parts-edit/${row.partsCode}`);
  }
  handleSearch(data) {
    this.mix_pageNum = 1;
    data.forEach(item => {
      if (item.prop) {
        this.searchForm[item.prop] = item.prop === "categoryCode" ? item.value[item.value.length - 1] : item.value;
      }
    });
    console.log(this.searchForm);
    this.loadListData();
  }
  handleOpPartsShowChange() {
    this.loadListData();
  }
}
